package pt.at.oss.kotlin.manual.validator.common

import pt.at.oss.kotlin.manual.enumeration.CustomErrorCodes
import pt.at.oss.kotlin.manual.storage.common.supplycommencement.SupplyCommencement
import pt.at.oss.kotlin.manual.time.OSS_START_DATE
import pt.at.oss.kotlin.manual.time.parseDate
import pt.lightweightform.kotlin.type.validator.ValidationCodes
import pt.lightweightform.kotlin.type.validator.ValidationError

/**
 * Created by Pedro Alfaiate on 15/05/2020.
 */
object SupplyCommencementValidator {
    val validateSupplyCommencementSequencial = fun(supplyCommencement: SupplyCommencement): List<ValidationError> {
        val errors = mutableListOf<ValidationError>()
        // alreadyCarriedOutSupplies
        // ->required
        validateRequiredBoolIf(supplyCommencement.alreadyCarriedOutSupplies, true)
            ?.also { errors.add(it) } // We need to validate isRequired because BooleanSchema doesn't support isRequired

        // commencementDate
        errors.addAll(
            validateCommencementDateSequencial(
                supplyCommencement.commencementDate,
                supplyCommencement.alreadyCarriedOutSupplies ?: false
            )
        )

        return errors
    }

    val validateCommencementDateSequencial = fun(commencementDate: String?, shouldExist: Boolean): List<ValidationError> {
        val errors = mutableListOf<ValidationError>()
        // ->required if alreadyCarriedOutSupplies=true
        validateRequiredStrIf(commencementDate, shouldExist)?.also { errors.add(it) }
        // ->prohibited otherwise
        // ->greater than OSS_START_DATE
        errors.addAll(validateCommencementDateValue(commencementDate, shouldExist))

        return errors
    }

    val validateCommencementDateValue = fun(commencementDate: String?, shouldExist: Boolean): Array<ValidationError> {
        val errors = mutableListOf<ValidationError>()
        // ->prohibited otherwise
        if (!shouldExist && !commencementDate.isNullOrBlank()) errors.add(ValidationError(code = CustomErrorCodes.COMMENCEMENT_DATE_NOT_ALLOWED.code))
        if (shouldExist && !commencementDate.isNullOrBlank()) {
            // Note: Remove format check when schemas actually do it...
            try {
                val commencement = parseDate(commencementDate!!) // aka firstSupplyDate
                // -> first supply should be greater than OSS_START_DATE
                if (commencement.utc < OSS_START_DATE.utc) errors.add(ValidationError(code = CustomErrorCodes.COMMENCEMENT_DATE_BEFORE_OSS_START.code))
            } catch (ex: Exception) {
                errors.add(ValidationError(code = ValidationCodes.LF_DATE_UNSUPPORTED_FORMAT))
            }
        }

        return errors.toTypedArray()
    }
}
